import {waitForPolyfill} from "../../util/polyfill-helper";

function apply(scope) {
  const topLevels = scope.querySelectorAll(".menu-hierarchy-level.top-level");
  topLevels.forEach(topLevel => {
    const topLevelBoundingBox = topLevel.getBoundingClientRect();
    topLevel.querySelectorAll(".menu-hierarchy-level").forEach(subLevel => {
      // show the sublevel and reset the transformation, so we can measure its bounding box
      subLevel.style.display = "flex";
      subLevel.style.transform = null;
      const subLevelBoundingBox = subLevel.getBoundingClientRect();
      if(subLevelBoundingBox.right > topLevelBoundingBox.right) {
        subLevel.style.transform = `translateX(${topLevelBoundingBox.right - subLevelBoundingBox.right}px)`;
      }

      // hide it again after measuring
      subLevel.style.display = null;
    });
  });
}

/**
 * Fixes the positions of the submenu <ul>s so they don't clip outside the top level <ul>
 * This function is obsolete once browser support for anchor-positioning is available and is not used
 * in browsers that support it.
 * @param scope
 */
function fixSubMenuPositions(scope) {
  // if the browser supports anchor-positioning, do not apply the workaround
  if ("anchorName" in document.documentElement.style) {
    return;
  }
  // apply immediately
  apply(scope);

  setTimeout(() => apply(scope), 0);
  // fix the position again after the polyfill applies
  waitForPolyfill("css-anchor-positioning", () => apply(scope));
}

export {fixSubMenuPositions}
